import { useCategoriesComparison } from "../categories-context";
import { CreatedIndustryEditorOnArrival } from "../market-builder/components/createdIndustryEditor/CreatedIndustryEditorOnArrival";
import { MarketResearchOverviewAll } from "../overview/Market-research-overview/layouts/MarketResearchOverviewAll";
import { MarketResearchOverviewComparison } from "../overview/Market-research-overview/layouts/MarketResearchOverviewComparison";
import { MarketResearchOverviewCustom } from "../overview/Market-research-overview/layouts/MarketResearchOverviewCustom";
import { MarketResearchOverviewCustomWithSegments } from "../overview/Market-research-overview/layouts/MarketResearchOverviewCustomWithSegments";
import { MarketResearchOverviewPreDefined } from "../overview/Market-research-overview/layouts/MarketResearchOverviewPreDefined";
import { resolveLayoutState, ELayoutState } from "../overview/Market-research-overview/utils/resolveLayoutState";

const LAYOUT_COMPONENTS = {
    [ELayoutState.PRE_DEFINED_INDUSTRY]: MarketResearchOverviewPreDefined,
    [ELayoutState.PRE_DEFINED_INDUSTRY_ALL]: MarketResearchOverviewAll,
    [ELayoutState.CUSTOM_INDUSTRY]: MarketResearchOverviewCustom,
    [ELayoutState.CUSTOM_INDUSTRY_WITH_SEGMENTS]: MarketResearchOverviewCustomWithSegments,
};

export const MarketResearchOverviewRoute = () => {
    const { hasMultipleCategories } = useCategoriesComparison();

    const LayoutComponent = hasMultipleCategories
        ? MarketResearchOverviewComparison
        : LAYOUT_COMPONENTS[resolveLayoutState()];

    return (
        <>
            <CreatedIndustryEditorOnArrival />
            <LayoutComponent />
        </>
    );
};
